/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.tableauDefilant.ts
 *
 * Textes du repère « tableau plus large que l'écran » (2026-10-15, demande
 * de Mika : sur l'écran Exposants, on ne comprenait pas que le tableau se
 * fait défiler vers la droite pour atteindre les colonnes Premium et
 * Platinium). Fusionné dans fr.ts. Mikael - chef de projet - 2026-10-15
 */
export const messagesTableauDefilantFr: Record<string, string> = {
  'tableauDefilant.consigne':
    'Le tableau est plus large que l’écran : faites-le défiler vers la droite pour voir toutes les colonnes.',
  'tableauDefilant.droite': 'Colonnes suivantes',
  'tableauDefilant.gauche': 'Colonnes précédentes',
  'tableauDefilant.region': 'Tableau, défilement horizontal',
};
